import * as React from "react";
import moment from "moment";
const DaysOfData = ({ dataLake }) => {
  const days = !dataLake.timestamp_from || !dataLake.timestamp_to ? 0 : moment(dataLake.timestamp_to).diff(dataLake.timestamp_from, "days");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, days);
};
export default DaysOfData;
